import { useEffect } from 'react';

import { useNavigate } from 'react-router';

import { Box } from '@/shared/ui';
import Loader from '@/shared/ui/feedback/Spinner';

import { useTokenAuth } from './useTokenAuth';

export const TokenAuth = () => {
  const { isReady } = useTokenAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (isReady) {
      navigate('/');
    }
  }, [isReady, navigate]);

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        height: '100vh'
      }}
    >
      <Loader />
    </Box>
  );
};
